import classNames from "classnames/bind";

import styles from "../Testimonials.module.scss";

const cx = classNames.bind(styles);

const MAX_VALUE = 5;

const Rating = ({ rating, maxValue = MAX_VALUE }: { rating: number; maxValue?: number }) => {
    return (
        <div className={cx("rating")} aria-label={`rating ${rating} of ${maxValue}`}>
            {[...Array(maxValue)].map((_, i) => (
                <div
                    key={i}
                    className={cx("star", { filled: i <= rating })}
                    data-value={(rating - i).toFixed(1)}
                ></div>
            ))}
        </div>
    );
};

export default Rating;
